var module = angular.module('octopusApp.configuration');

module.controller('CertificatesIndexController', function($scope, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  var certs = octopusRepository.Certificates;

  isLoading.promises([
    certs.getOctopusCertificate().then(function(octo) {
      $scope.octopusCertificate = octo;
    })
  ]);
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/certificates/controllers/certificates_index_controller.js
// module id = 384
// module chunks = 1